module.exports = __webpack_public_path__ + "img/icon_fbmess-white.dd7cb039.svg";